import type { SVGProps } from 'react';
const SvgPrintDisabled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#print_disabled_svg__a)">
      <path
        fill="currentColor"
        d="M19.1 17H22v-6c0-1.7-1.3-3-3-3h-9l9.1 9Zm-.1-7c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1Zm-1-3V3H6v1.1L9 7h9ZM1.2 1.8 0 3l4.9 5C3.3 8.1 2 9.4 2 11v6h4v4h11.9l3 3 1.3-1.3-21-20.9ZM8 19v-5h2.9l5 5H8Z"
      />
    </g>
    <defs>
      <clipPath id="print_disabled_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPrintDisabled;
